module.exports = __webpack_public_path__ + "static/media/renBTC-BTC.1731ff10.png";